{	search: { "en": "Search",
		"es": "Buscar",
		"pt": "Pesquisar"},
	label: { "en": "Label",	
		"es": "Etiqueta",	
		"pt": "Etiqueta"},
	showmore: { "en": "Show more",	
		"es": "Mostrar más",	
		"pt": "Mostrar mais"},
	all: { "en": "ALL",
		"es": "TODOS",
		"PT": "TODOS"},
	moreinfo: { "en": "More information",
		"es": "Más información"},
	user: { "en": "User",
		"es": "Usuario"},
	homelocrel: { "en": "..",
		"es": "../es"},
	
	
	flaglang: { "en": "🇬🇧 EN",
		"es": "🇪🇸 ES"},
	
	
	starting: { "en": "Starting EducaWood",
		"es": "Iniciando EducaWood"},
	confdata: { "en": "Configuring data services",
		"es": "Configurando los servicios de datos"},
	conftaxon: { "en": "Extracting taxonomic data",
		"es": "Extrayendo datos de taxones"},
		
	
	spinnerLoading: { "en": "Loading data...",
		"es": "Cargando datos..."},
	spinnerInfo: { "en": "We are querying our fancy databases.",
		"es": "Estamos consultando a nuestras molonas bases de datos."},
		
	
	ntrees: { "en": " trees in this area",
		"es": " árboles en esta zona"},

	
	questtext: { "en": "Please answer a questionnaire<br>to help us to improve.",
		"es": "Responde a un cuestionario<br>para ayudarnos a mejorar.",
		"pt": "Quer responder a um questionário<br>para nos ajudar a melhorar?"},
	questurl: { "en": "https://docs.google.com/forms/d/e/1FAIpQLSdj2YL-1yZFMFBi0dWHDnlOKp5oWg_58DkM7fAWykSgmONKZw/viewform?usp=sf_link",
		"es": "https://docs.google.com/forms/d/e/1FAIpQLSdjLezgl169v5nCY2Y1bLskDimEy_rbDwO4GhMdQ2YdKijmPg/viewform?usp=sf_link"},
	yes: { "en": "Yes",
		"es": "Sí",
		"pt": "Sim"},
	no: { "en": "No",
		"es": "No",
		"pt": "Não"},
	later: { "en": "Maybe later",
		"es": "Más tarde",
		"pt": "Talvez mais tarde"},


	errorEndpointTitle: { "en": "Data provider not accessible",
		"es": "No puede accederse al proveedor de datos",
		"pt": "Provedor de dados não acessível"},
	errorEndpointText: { "en": "The data provider is temporarily not accessible. \
			We apologize for the inconvenience and recommend to try later.",
		"es": "El proveedor de datos está temporalmente no disponible. \
			Lamentamos este inconveniente y recomendamos que pruebe más tarde.",
		"pt": "Servidor de dados está temporariamente indisponível. \
			Pedimos desculpas pelo transtorno e recomendamos que tente mais tarde."},		
	close: { "en": "Close",
		"es": "Cerrar",
		"pt": "Fechar"},
		

	errorEducatreeTitle: { "en": "The tree does not exist",
		"es": "No existe el árbol"},
	errorEducatreeText: { "en": "There is no tree with identifier ",
		"es": "No existe un árbol con identificador "},
		

	zoomin: { "en": "Zoom in",
		"es": "Más zoom",
		"pt": "Aproximar"},
	zoomout: { "en": "Zoom out",
		"es": "Menos zoom",
		"pt": "Afastar"},
	mylocation: { "en": "My location",
		"es": "Mi localización",
		"pt": "Minha localização"},
		
	
	viewIFN: { "en": "View IFN trees",
		"es": "Ver árboles IFN"},
	refresh: { "en": "Refresh data",
		"es": "Refrescar datos"},
	esri: { "en": "Esri layer",
		"es": "Capa Esri"},
	downloadData: { "en": "Download data",
		"es": "Descargar datos"},
	tour: { "en": "Tour",
		"es": "Tour"},
	fullmap: { "en": "Full map",
		"es": "Mapa completo"},
		

	download: { "en": "Download",
		"es": "Descargar"},
	downloadData: { "en": "Download data",
		"es": "Descargar datos"},
	cancelPolygon:  { "en": "Cancel polygon",	
		"es": "Cancelar polígono" },
	finish:  { "en": "Finish",	
		"es": "Terminar" },
	finishPolygon:  { "en": "Finish polygon",	
		"es": "Terminar polígono" },
	deleteLastPoint:  { "en": "Delete last point",	
		"es": "Borrar último punto" },
	deleteLastPointDrawn:  { "en": "Delete last point drawn",	
		"es": "Borrar último punto dibujado" },
	startPolygon: { "en": "Click to start drawing the polygon.",
		"es": "Clica para empezar a dibujar el polígono."}, 
	contPolygon: { "en": "Click to continue drawing the polygon.",
		"es": "Clica para continuar dibujando el polígono."},
	endPolygon: { "en": "Click first point to close the polygon.",
		"es": "Clica el primer punto para cerrar el polígono."},
	errorPolygon: { "en": "<strong>Error:</strong> polygon lines cannot cross!",
		"es": "<strong>Error:</strong> ¡no pueden cruzarse las líneas del polígono!"},
	downloadMessage: { "en": "You will retrieve tree data within the polygon you have just drawn.",
		"es": "Obtendrás los datos de los árboles en el polígono que acabas de dibujar."},
	downloadMessagePrev: { "en": "You will get a file with the trees located within the currently visible area of the map:",
		"es": "Obtendrás un fichero con los árboles comprendidos en la zona visible del mapa:"},
	downloadChoices: { "en": "Choose what to download:",
		"es": "Elige qué quieres descargar:"},
	checkTrees: { "en": "Summarized reports of EducaWood trees",
		"es": "Fichas resumidas de árboles de EducaWood"},
	checkAnnotations: { "en": "All annotations of EducaWood trees",
		"es": "Todas las anotaciones de los árboles de EducaWood"},
	downloadClusterNote: { "en": "Downloaded data may include tree clusters if the zoom is too low.",
		"es": "Los datos descargados pueden incluir agrupaciones de árboles si el zoom es demasiado bajo."},
	downloadNothing: { "en": "Nothing to download!",
		"es": "¡No hay nada que descargar!"},
	downloadNoFormat: { "en": "No format selected!",
		"es": "¡No hay formato seleccionado!"},
	downloadFormatChoose: { "en": "Choose your preferred data format:",
		"es": "Elige el formato de datos:"},
	downloadingTrees: { "en": "Downloading EducaWood trees",
		"es": "Descargando árboles de EducaWood"},
	treesDownloaded: { "en": "EducaWood trees downloaded",
		"es": "Árboles de EducaWood descargados"},
	noTreesDownloaded: { "en": "No EducaWood trees to download",
		"es": "No había árboles de EducaWood para descargar"},
	educawoodTrees: { "en": "EducaWood trees",
		"es": "árboles de EducaWood"},
	educawoodClusters: { "en": "tree clusters",
		"es": "agrupaciones de árboles"},
	downloadingAnnotations: { "en": "Downloading annotations of EducaWood trees",
		"es": "Descargando anotaciones de árboles de EducaWood"},
	educawoodAnnotations: { "en": "annotations of EducaWood trees",
		"es": "anotaciones de árboles de EducaWood"},
	noAnnotationsDownloaded: { "en": "No annotations of EducaWood trees to download",
		"es": "No había anotaciones de árboles de EducaWood para descargar"},
	downloadSuccess: { "en": "Download successful",
		"es": "Descarga de datos exitosa"},
	

	toastDownload: { "en": "Wait until all data has been retrieved.",
		"es": "Espera a que acabe de recuperar los datos."},
	toastDownloadPolygon: { "en": "Draw a polygon for the data download",
		"es": "Dibuja un polígono para la descarga de datos"},
	toastZoom: { "en": "You need to zoom in to create trees.",
		"es": "Para crear árboles tienes que aumentar el zoom."},
	toastUser: { "en": "You need to sign up (top-right button) to create trees.",
		"es": "Necesitas iniciar sesión (botón superior derecha) para crear árboles."},
	toastCreateTree: { "en": "Push the map location where the new tree is situated.",
		"es": "Pulsa la posición del mapa en la que el nuevo árbol está situado."},
	
	
	
	home: { "en": "Home",
		"es": "Inicio",
		"pt": "Início"},
	map: { "en": "Map",
		"es": "Mapa"},
	lastTrees: { "en": "Last trees",
		"es": "Últimos árboles"},


	color0: { "en": "Green",
		"es": "Verde",
		"pt": "Verde"},
	color1: { "en": "Gray",
		"es": "Gris",
		"pt": "Cinzento"},
	color2: { "en": "Blue gray",
		"es": "Gris azulado",
		"pt": "Cinzento azulado"},
	color3: { "en": "Orange",
		"es": "Naranja",
		"pt": "Laranja"},
	color4: { "en": "Blue",
		"es": "Azul",
		"pt": "Azul"},
	color5: { "en": "Pink",
		"es": "Rosa",
		"pt": "Rosa"},
	color6: { "en": "Purple",
		"es": "Violeta",
		"pt": "Roxo"},
	color7: { "en": "Indigo",
		"es": "Añil",
		"pt": "Azul índigo"},
	color8: { "en": "Cyan",
		"es": "Celeste",
		"pt": "Ciano"},
	color9: { "en": "Brown",
		"es": "Marrón",
		"pt": "Castanho"},


	searchplace: { "en": "Search place...",	
		"es": "Buscar lugar...",	
		"pt": "Pesquisar lugar..."},
	noplacesfound: { "en": "No places matched",	
		"es": "No hay lugares que coincidan",	
		"pt": "Nenhum lugar encontrado"},
	population: { "en": "Population",
		"es": "Población",
		"pt": "População"},
	PPLC: { "en": "Capital of a country",
		"es": "Capital de país",
		"pt": "Capital de país"},
	PPLA: { "en": "Seat of an autonomous region",
		"es": "Capital de comunidad autónoma",
		"pt": "Capital de uma região autónoma"},
	PPLA2: { "en": "Seat of a province",
		"es": "Capital de provincia",
		"pt": "Capital de uma província"},
	PPLA3: { "en": "Municipality",
		"es": "Municipio",
		"pt": "Município"},
	PPLA4: { "en": "Populated place",
		"es": "Población",
		"pt": "Povoação"},
	PPL: { "en": "Populated place",
		"es": "Población",
		"pt": "Povoação"},
	FRST: { "en": "Forest",
		"es": "Bosque",
		"pt": "Floresta"},
	HLL: { "en": "Hill",
		"es": "Cerro",
		"pt": "Colina"},
	HLLS: { "en": "Hills",
		"es": "Cerros",
		"pt": "Colinas"},
	MT: { "en": "Mountain",
		"es": "Montaña",
		"pt": "Montanha"},
	MTS: { "en": "Mountains",
		"es": "Montañas",
		"pt": "Montanhas"},
	PRK: { "en": "Park",
		"es": "Parque",
		"pt": "Parque"},
	RDGE: { "en": "Ridge",
		"es": "Sierra",
		"pt": "Cume"},
	RES: { "en": "Reserve",
		"es": "Reserva",
		"pt": "Reserva"},
	RESF: { "en": "Forest reserve",
		"es": "Reserva forestal",
		"pt": "Reserva florestal"},
	RESN: { "en": "Nature reserve",
		"es": "Reserva natural",
		"pt": "Reserva natural"},
	RESW: { "en": "Wildlife reserve",
		"es": "Reserva natural",
		"pt": "Reserva natural"},
	VAL: { "en": "Valley",
		"es": "Valle",
		"pt": "Vale"},
	VALG: { "en": "Hanging valley",
		"es": "Valle glaciar",
		"pt": "Vale glaciar"},		


	taxonfilter: { "en": "Taxon",	
		"es": "Taxón",
		"pt": "Táxon"},
	filter: { "en": "Filter",	
		"es": "Filtrar",
		"pt": "Filtro"},
	filtering: { "en": "Filtering",	
		"es": "Filtrando",
		"pt": "Filtrando"},
	removefilter: { "en": "Remove filter",	
		"es": "Quitar filtro",
		"pt": "Remover filtro"},
	searchtaxon: { "en": "Search taxon...",	
		"es": "Buscar taxón...",
		"pt": "Pesquisar táxon..."},
	notaxonfound: { "en": "No taxon matched",	
		"es": "No hay taxones que coincidan",
		"pt": "Não há taxa que coincidam"},
	taxonid: { "es": "Taxon with id ",	
		"es": "Taxón con id ",
		"pt": "Táxon com id "},
	nomci: { "en": "Scientific names",	
		"es": "Nombres científicos",
		"pt": "Nomes científicos"},
	taxoninfo: { "en": "Taxon info",	
		"es": "Información de taxón",
		"pt": "Informação de táxon"},
	speciesinfo: { "en": "Species info",	
		"es": "Información de especies",
		"pt": "Informação de espécie"},		
	species: { "en": "Species",	
		"es": "Especie",
		"pt": "Espécie"},
	genus: { "en": "Genus",	
		"es": "Género",
		"pt": "Género"},
	family: { "en": "Family",	
		"es": "Familia",
		"pt": "Família"},
	class: { "en": "Class",	
		"es": "Clase",
		"pt": "Classe"},


	importtaxon:  { "en": "Import taxon",
		"es": "Importar taxón" },
	typesomething:  { "en": "Type something.",
		"es": "Escribe algo." },
	typesomethingmore:  { "en": "Type something more.",
		"es": "Escribe algo más." },
	notaxonsfound:  { "en": "No taxons found",
		"es": "No se encontraron taxones" },
	obtainingtaxons:  { "en": "Obtaining taxons...",	
		"es": "Recuperando taxones..." },
	tryanotherstring:  { "en": "Try another string.",	
		"es": "Prueba con otra cadena." },
	selectataxon:  { "en": "Select a taxon.",	
		"es": "Selecciona un taxón." },
	obtainingtaxondata:  { "en": "Obtaining taxon data...",	
		"es": "Recuperando los datos del taxón..." },
	obtainingtaxondata:  { "en": "Obtaining taxon data...",	
		"es": "Recuperando los datos del taxón..." },
	readytoimport:  { "en": "Ready to import.",
		"es": "Listo para importar." },
	taxonalreadyimported:  { "en": '<b style="color:red;">Taxon already imported!</b>',
		"es": '<b style="color:red;">¡El taxón ya ha sido importado!</b>' },
	importingthetaxon:  { "en": "Importing the taxon. Please wait...",
		"es": "Importando el taxón. Por favor, espera..." },
	taxonimported:  { "en": "Taxon imported.",
		"es": "Taxón importado." },
	taxonimportingerror: { "en": "Error importing the taxon",	
		"es": "Error al importar el taxón" },
		

	createtree: { "en": "Create tree",	
		"es": "Crear árbol" },
	newtree:  { "en": "New tree",	
		"es": "Nuevo árbol" },
	formopt: { "en": "All form elements are optional.",	
		"es": "Todos los elementos del formulario son opcionales." },
	signupToCreate: { "en": "Sign in to create trees.",	
		"es": "Inicia sesión para crear árboles." },
	location:  { "en": "Location",	
		"es": "Localización" },
	position:  { "en": "Position (WGS 84)",
		"es": "Posición (WGS 84)" },
	dragmarker:  { "en": "Drag the red marker to change the location of the new tree.",	
		"es": "Desplaza el marcador rojo para cambiar la localización del nuevo árbol." },
	mapclue:  { "en": "Drag the map to change the position of the tree (red marker).",	
		"es": "Desplaza el mapa para cambiar la posición del árbol (marcador rojo)." },
	treenick:  { "en": "Tree nick",
		"es": "Apodo árbol" },
	treetaxon:  { "en": "Tree taxon",
		"es": "Taxón árbol" },
	photo:  { "en": "Photo",	
		"es": "Foto" },
	nophoto:  { "en": "No tree photo.",	
		"es": "No hay foto del árbol." },
	photouploaded:  { "en": "Tree photo uploaded.",
		"es": "Foto del árbol subida."},
	partplanselection: { "en": "Select the part of the tree in the photo",
		"es": "Selecciona la parte del árbol en la foto"},
	heightm:  { "en": "Height (m)",	
		"es": "Altura (m)" },
	enterheightm:  { "en": "Tree height in meters",	
		"es": "Altura del árbol en metros" },
	diametermm:  { "en": "Diameter (mm)",	
		"es": "Diámetro (mm)" },
	enterdiametermm:  { "en": "Tree diameter at breast height in millimeters",	
		"es": "Diámetro del árbol a la altura del pecho en milímetros" },
	perimetermm:  { "en": "Perimeter (mm)",	
		"es": "Perímetro (mm)" },
	enterperimetermm:  { "en": "Tree perimeter at breast height in millimeters",
		"es": "Perímetro del árbol a la altura del pecho en milímetros" },
	treeobservation:  { "en": "Observation",
		"es": "Observación"},
	yourobservation:  { "en": "Your observation",
		"es": "Tu observación"},
	cancel:  { "en": "Cancel",	
		"es": "Cancelar" },
	treeStatus:	{ "en": "Tree status",	
		"es": "Estado árbol" },
	treestatusselection: { "en": "Select tree status",	
		"es": "Selecciona el estado del árbol" },
	AliveTreeAnnotation: { "en": "Alive tree",	
		"es": "Árbol vivo" },
	DecliningTreeAnnotation: { "en": "Declining tree",	
		"es": "Árbol en declive" },
	DeadTreeAnnotation:	{ "en": "Dead tree",	
		"es": "Árbol muerto" },
	DeadTreeWithBarkAnnotation:	{ "en": "Dead tree with bark",	
		"es": "Árbol muerto con corteza" },
	DeadTreeWithLooseBarkAnnotation:	{ "en": "Dead tree with loose bark",	
		"es": "Árbol muerto con corteza suelta" },
	DeadTreeWithNoBarkAnnotation:	{ "en": "Dead tree with no bark",	
		"es": "Árbol muerto sin corteza" },
	DecomposedTreeAnnotation:	{ "en": "Decomposed dead tree",	
		"es": "Árbol descompuesto" },
	StumpAnnotation: { "en": "Stump",	
		"es": "Tocón" },
	uploadingphoto:	{ "en": "Uploading photo...",	
		"es": "Subiendo foto..." },
	uploadingphotoerror: { "en": "Error uploading the photo",	
		"es": "Error al subir la foto" },
	deletingphotoerror: { "en": "Error deleting the photo",	
		"es": "Error al borrar la foto" },
	creatingtree:	{ "en": "Creating the tree...",	
		"es": "Creando el árbol..." },
	treecreationerror: { "en": "Error creating the tree",	
		"es": "Error al crear el árbol" },
	treecreationsuccess: { "en": "The tree has been created",	
		"es": "Se ha creado el árbol" },
	pleasewait:	{ "en": "Please wait.",	
		"es": "Por favor, espere" },
	back:	{ "en": "Go back",
		"es": "Volver" },
	viewtree:	{ "en": "View tree",
		"es": "Ver árbol" },
	
	
	newAnnotation:	{ "en": "New annotation",
		"es": "Nueva anotación" },
	createAnnotation:	{ "en": "Create annotation",
		"es": "Crear anotación" },
	noAnnotation:	{ "en": "No annotation.",
		"es": "No hay anotación." },
	sameAnnotation:	{ "en": "Same annotation as the current value.",
		"es": "Misma anotación que el valor actual." },
	outOfRangeAnnotation:	{ "en": "Out of range annotation.",
		"es": "Anotación fuera de rango." },
	deleteAnnotation:	{ "en": "Delete annotation",
		"es": "Borrar anotación" },
	deleteAnnotationInfo:	{ "en": "Are you sure that you want to delete this annotation? This action cannot be reversed.",
		"es": "¿Estás seguro de que quieres borrar esta anotación? Esta acción no puede revertirse." },
	deletingAnnotation:	{ "en": "Deleting the annotation...",
		"es": "Borrando la anotación..." },
	deleteAnnotationError:{ "en": "Error deleting the annotation",	
		"es": "Error al borrar la anotación" },
	deleteAnnotationSuccess:{ "en": "The annotation has been deleted",	
		"es": "Se ha borrado la anotación" },
	creatingannotation:	{ "en": "Creating the annotation...",	
		"es": "Creando la anotación..." },
	treeannotationerror: { "en": "Error creating the annotation",	
		"es": "Error al crear la anotación" },
	treeannotationsuccess: { "en": "The annotation has been created",	
		"es": "Se ha creado la anotación" },
	formerPositions: { "en": "Former positions",
		"es": "Posiciones anteriores" },
	formerTreeTaxons: { "en": "Former taxons",
		"es": "Taxones anteriores" },
	formerTreeStatus: { "en": "Former statuses",
		"es": "Estados anteriores" },
	formerHeights: { "en": "Former heights",
		"es": "Alturas anteriores" },
	formerDiameters: { "en": "Former diameters",
		"es": "Diámetros anteriores" },
	observations: { "en": "Observations",
		"es": "Observaciones" },
	moreobservations: { "en": "More observations",
		"es": "Más observaciones" },
	

	delete:	{ "en": "Delete",
		"es": "Borrar" },
	deleteTree:	{ "en": "Delete the tree",
		"es": "Borrar el árbol" },
	deleteTreeInfo:	{ "en": "Are you sure that you want to delete this tree and all its associated data? This action cannot be reversed.",
		"es": "¿Estás seguro de que quieres borrar este árbol y todos sus datos? Esta acción no puede revertirse." },		
	deletingtree:	{ "en": "Deleting the tree...",	
		"es": "Borrando el árbol..." },
	treedeletionerror: { "en": "Error deleting the tree",	
		"es": "Error al borrar el árbol" },
	treedeletionsuccess: { "en": "The tree has been deleted",	
		"es": "Se ha borrado el árbol" },
		
	
	tree: { "en": "Tree",	
		"es": "Árbol",
		"pt": "Árvore"},
	trees: { "en": "trees",	
		"es": "árboles",
		"pt": "árvores"},
	height: { "en": "Height",	
		"es": "Altura",
		"pt": "Altura"},
	diameter: { "en": "Diameter",	
		"es": "Diámetro",
		"pt": "Diâmetro"},
	created: { "en": "Created",	
		"es": "Creación"},
	createdBy: { "en": "Created by ",	
		"es": "Creado por ",
		"pt": "Criado por "},
	annotatedBy: { "en": "Annotated by ",	
		"es": "Anotado por "},
	createdByIFN: { "en": "Source IFNv3",	
		"es": "Fuente IFNv3",
		"pt": "Fonte IFNv3"},
	onDate: { "en": " on ",	
		"es": " el "},
	ofTree: { "en": " of",	
		"es": " del"},
	createdOn: { "en": "Created on ",	
		"es": "Creado el "},
	creator: { "en": "Creator ",	
		"es": "Creador"},
	annotationType: { "en": "Type",	
		"es": "Tipo"},
	date: { "en": "Date",	
		"es": "Fecha"},
	annotator: { "en": "Annotator",	
		"es": "Anotador"},
	annotatedOn: { "en": "Annotated on ",	
		"es": "Anotado el "},
	noCreatedTrees: { "en": "No created trees",	
		"es": "Ningún árbol creado"},
	noAnnotations: { "en": "No annotations",	
		"es": "Ninguna anotación"},
	lastCreatedTrees: { "en": "Last created trees",	
		"es": "Últimos árboles creados"},
	lastAnnotations: { "en": "Last annotations",	
		"es": "Últimas anotaciones"},
	page: { "en": "Page",	
		"es": "Página"},
		
		
	latitude: { "en": "lat",
		"es": "lat"},
	longitude: { "en": "lng",
		"es": "lng"},		
	

	signin: { "en": "Sign in",
		"es": "Inicia sesión"},
	signout: { "en": "Sign out",
		"es": "Salir"},
	viewProfile: { "en": "View profile",
		"es": "Ver perfil"},
	newNick: { "en": "New nick",
		"es": "Nuevo apodo"},
	newTreeNick: { "en": "New tree nick",
		"es": "Nuevo apodo del árbol"},
	changeNick: { "en": "Change nick",
		"es": "Cambiar apodo"},
	change: { "en": "Change",
		"es": "Cambiar"},
	newNickTip: { "en": "Your cool new nick...",
		"es": "Tu nuevo apodo..."},
	newTreeNickTip: { "en": "A cool nick for this tree...",
		"es": "Un apodo para este árbol..."},
	noNick: { "en": "No nick.",
		"es": "No hay apodo."},
	nickTooshort: { "en": "Nick too short.",
		"es": "Apodo demasiado corto."},
	nickToolong: { "en": "Nick too long.",
		"es": "Apodo demasiado largo."},
	checkingNick: { "en": "Checking the nick...",
		"es": "Comprobando el apodo..."},
	nickTaken: { "en": "Nick already taken.",
		"es": "Apodo ya cogido."},
	changeNickSuccess: { "en": "Nick changed",
		"es": "Apodo cambiado"},
	changeNickFailure: { "en": "Nick change failed",
		"es": "Falló el cambio de apodo"},
	changeTreeNickSuccess: { "en": "Tree nick changed",
		"es": "Apodo de árbol cambiado"},
	changeTreeNickFailure: { "en": "Tree nick change failed",
		"es": "Falló el cambio de apodo del árbol"},
	errorUserTitle: { "en": "The user does not exist",
		"es": "No existe el usuario"},
	errorUserText: { "en": "There is no user with identifier ",
		"es": "No existe un usuario con identificador "},
	userActive: { "en": "📅 active since ",
		"es": "📅 activo desde "},
	isMaster: { "en": "😎 is master",
		"es": "😎 es máster"},
	cannotAnnotate: { "en": "💀 cannot annotate",
		"es": "💀 no puede anotar"},
	oneTreeCreated:{ "en": "🌳 creator of one tree",
		"es": "🌳 creador de un árbol"},
	multipleTreesCreated:{ "en": "🌳 creator of %d trees",
		"es": "🌳 creador de %d árboles"},
	oneAnnotation:{ "en": "🌲 creator of one annotation",
		"es": "🌲 creador de una anotación"},
	multipleAnnotations:{ "en": "🌲 creator of %d annotations",
		"es": "🌲 creador de %d anotaciones"},
		

	local: { "en": "en",	
		"es": "es",
		"pt": "pt"},
		

	tourTitle0: { "en": "Welcome",
		"es": "Bienvenido"},
	tourText0: { "en": "Welcome to EducaWood! There are a lot of things you can do with this application. Let's review the map controls.<br><br><i>You can exit this tour at any time by pushing the 'X'.</i>",
		"es": "¡Bienvenido a EducaWood! Hay muchas cosas que puedes hacer con esta aplicación. Empecemos revisando los controles.<br><br><i>Puedes salir de este tour en cualquier momento pulsando la 'X'.</i>"},
	tourTitle1: { "en": "The map",
		"es": "El mapa"},
	tourText1: { "en": "This is the main screen of EducaWood. Most of the actions in the application are initiated in this view.<br>You can use the touchscreen (or the mouse in PCs) for panning and zooming the map.",
		"es": "Ésta es la pantalla principal de EducaWood. La mayoría de las acciones posibles se inician aquí.<br>Puedes usar la pantalla táctil (o el ratón si es un PC) para mover el mapa o para hacer zoom."},
	tourTitle2: { "en": "Zoom buttons",
		"es": "Botones de zoom"},
	tourText2: { "en": "You can also use these buttons for zooming in or out.",
		"es": "También puedes usar estos botones para controlar el nivel de zoom."},
	tourTitle3: { "en": "My location",
		"es": "Mi localización"},
	tourText3: { "en": "Push this button to center the map in your current location. Please note that you need to grant permission to your browser.<br>In case of success, a blue dot will mark your location in the map (precision can vary).<br>Push the button again to remove the blue dot.",
		"es": "Pulsa este botón para centrar el mapa en tu posición actual. Ten en cuenta que necesitas dar permiso al navegador para obtener tu posición. En caso de éxito, un punto azul marcará tu posición en el mapa (la precisión puede variar).<br>Pulsa de nuevo el botón para esconder el punto azul."},
	tourTitle4: { "en": "Your profile",
		"es": "Tu perfil"},
	tourText4: { "en": "This is your avatar in EducaWood. Push it to view your profile or to sign out.",
		"es": "Éste es tu avatar en EducaWood. Pulsa en él para ver tu perfil o para cerrar la sesión."},
	tourTitle5: { "en": "Sign in",
		"es": "Inicia sesión"},
	tourText5: { "en": "Push to sign in (a Google account is needed). This allows you to create and annotate trees in EducaWood.",
		"es": "Pulsa para iniciar sesión (requiere una cuenta de Google). Esto te permite crear y anotar árboles en EducaWood."},
	tourTitle6: { "en": "Create trees",
		"es": "Crea árboles"},
	tourText6: { "en": "Push to create a new tree.<br>This button is only enabled if (1) you have signed in and (2) the zoom level is high enough.<br>After clicking this button, push the map location where the new tree will be created.",
		"es": "Pulsa para crear un árbol.<br>El botón sólo estará habilitado si (1) has iniciado sesión y (2) el nivel de zoom es suficientemente alto.<br>Tras clickar este botón, pulsa la localización del mapa en la que quieres crear el árbol."},
	tourTitle7: { "en": "View IFN trees",
		"es": "Ver árboles IFN"},
	tourText7: { "en": "Push to show the IFN trees in the map view.<br>IFN is the official Spanish inventory of trees, so this functionality is only useful in Spain.",
		"es": "Pulsa para mostrar los árboles del IFN en la vista del mapa.<br>IFN es el inventario oficial español de árboles, por lo que esta funcionalidad sólo es útil en España."},
	tourTitle7a: { "en": "Change map layer",
		"es": "Cambia la capa del mapa"},
	tourText7a: { "en": "Push to switch between the maps from OpenStreetMap and Esri.",
		"es": "Pulsa para alternar entre los mapas de OpenStreetMap y Esri."},
	tourTitle8: { "en": "Refresh data",
		"es": "Refrescar datos"},
	tourText8: { "en": "Push to force the application to gather fresh tree data from the server.<br>This is only needed to get the last minute updates, i.e. to obtain the trees that have just been created in the map view.",
		"es": "Pulsa para obligar a la aplicación a recuperar los últimos datos de árboles del servidor.<br>Esto sólo hace falta para obtener las actualizaciones del último minuto, es decir, los árboles que acaban de crearse en la vista del mapa."},
	tourTitle9: { "en": "Download data",
		"es": "Descarga de datos"},
	tourText9: { "en": "Download tree data in the visible area of the map.",
		"es": "Descarga los datos de árboles de la zona visible del mapa."},
	tourTitle10: { "en": "Filter taxon",
		"es": "Filtrar taxón"},
	tourText10: { "en": "Filter the trees in the map by taxon.",
		"es": "Filtra los árboles en el mapa por taxón."},
	tourTitle11: { "en": "Taxa names",
		"es": "Nombres de taxones"},
	tourText11: { "en": "Toggle button to choose between scientific or vulgar taxon names.",
		"es": "Botón para elegir entre nombres taxonómicos científicos o vulgares."},
	tourTitle12: { "en": "Search places",
		"es": "Buscar lugares"},
	tourText12: { "en": "Center the map in a specific a place by typing its name.",
		"es": "Centra el mapa en el lugar deseado al teclear su nombre."},
	tourTitle13: { "en": "More options",
		"es": "Más opciones"},
	tourText13: { "en": "Push to go to the landing or the last trees pages.",
		"es": "Pulsa para ir a las páginas de inicio o a la de últimos árboles creados."},
	tourTitle14: { "en": "The end",
		"es": "Hemos terminado"},
	tourText14: { "en": "That\'s all for now. Enjoy EducaWood!",
		"es": "Esto es todo por ahora. ¡Disfruta de EducaWood!"},
	tourExit: { "en": "Exit",
		"es": "Salir"},
	tourNext: { "en": "Next",
		"es": "Siguiente"},
	tourBack: { "en": "Back",
		"es": "Atrás"},
	tourDone: { "en": "Done",
		"es": "Hecho"}
}